// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4999 ? "f31aec94" : chunkId) + "." + {"4999":"56bd380de96540be","8802":"0809341ede7817bb"}[chunkId] + ".js";
};